import * as React from 'react';
import {
  BaSeTheme,
  BaSeContainer,
  BaSeButton,
  BaSeHeading2,
  BaSeHeading5,
  BaSeParagraph,
} from '@base/react';
import { StyledJumbotron } from '../../../components/shared/jumbotron/jumbotron-styled';
import { JumbotronProdutos } from '../produtos-styled';
import { BackWrapper } from '../../../components/gestao-arquivos/gestao-arquivos-styled';
import { VIEW_MODES } from '../hooks/useViewNavigation';

const getPageTitle = (viewMode) => {
  if (viewMode === VIEW_MODES.FILE_MANAGER || viewMode === VIEW_MODES.SEND_FILE) {
    return 'Gestão de arquivos';
  }
  return 'Produtos';
};

const getPageSubtitle = (viewMode, formTitle, fileManagerSubtitle) => {
  if (viewMode === VIEW_MODES.FORM) return formTitle;
  if (viewMode === VIEW_MODES.FILE_MANAGER || viewMode === VIEW_MODES.SEND_FILE) {
    return fileManagerSubtitle;
  }
  return 'Gestão';
};

const getBackButtonText = (viewMode) => {
  return viewMode === VIEW_MODES.SEND_FILE
    ? 'Voltar para Gestão de arquivos'
    : 'Voltar para Produtos';
};

export const PageHeader = ({
  viewMode,
  formTitle,
  fileManagerSubtitle,
  onNewProduct,
  onSendFile,
  onBack,
}) => {
  const showBackButton = viewMode === VIEW_MODES.FILE_MANAGER || viewMode === VIEW_MODES.SEND_FILE;
  const showNewProductButton = viewMode === VIEW_MODES.LIST;
  const showSendFileButton = viewMode === VIEW_MODES.FILE_MANAGER;

  return (
    <StyledJumbotron backgroundColor={BaSeTheme.colors.defaultColors.white}>
      <BaSeContainer delimitedOnBreakpoint="desktop">
        {showBackButton && (
          <BackWrapper onClick={onBack}>
            <BaSeParagraph
              link="#"
              color={BaSeTheme.colors.institucionais.azulSebrae36}
            >
              {getBackButtonText(viewMode)}
            </BaSeParagraph>
          </BackWrapper>
        )}
        <JumbotronProdutos>
          <div>
            <BaSeHeading2 color={BaSeTheme.colors.institucionais.azulSebrae30}>
              {getPageTitle(viewMode)}
            </BaSeHeading2>
            <BaSeHeading5 color={BaSeTheme.colors.institucionais.azulSebrae30}>
              {getPageSubtitle(viewMode, formTitle, fileManagerSubtitle)}
            </BaSeHeading5>
          </div>
          {showNewProductButton && (
            <BaSeButton
              value="Novo produto"
              onClick={onNewProduct}
              leftIcon="plus"
            />
          )}
          {showSendFileButton && (
            <BaSeButton
              value="Enviar arquivos"
              type="secondary"
              color={BaSeTheme.colors.institucionais.azulSebrae36}
              onClick={onSendFile}
            />
          )}
        </JumbotronProdutos>
      </BaSeContainer>
    </StyledJumbotron>
  );
};
